export const toastConfig = {
  style: {
    fontFamily: "'JetBrains Mono','IBM Plex Sans Thai','monospace'",
    fontWeight: '700',
  },
  success: {
    style: {
      background: '#D1FAE5',
    },
  },
  error: {
    style: {
      background: '#FEE2E2',
    },
  },
}
